export enum UserStatusHistoryDescriptionEnum {
  FIRST_CONNECTION = "FIRST_CONNECTION",
  CERTIFICATE_ASKED = "CERTIFICATE_ASKED",
  CERTIFICATE_IN_PROGRESS = "CERTIFICATE_IN_PROGRESS",
  CERTIFICATE_CREATED = "CERTIFICATE_CREATED",
  CERTIFICATE_REQUEST_REJECTED = "CERTIFICATE_REQUEST_REJECTED",
  CERTIFICATE_REVOKED = "CERTIFICATE_REVOKED",
  CERTIFICATE_REVOKED_INFORMATION = "CERTIFICATE_REVOKED_INFORMATION",
  CERTIFICATE_REVOKED_MOBILE = "CERTIFICATE_REVOKED_MOBILE",
  CERTIFICATE_REVOKED_RENEW = "CERTIFICATE_REVOKED_RENEW",
  CERTIFICATE_REVOKED_BUTTON = "CERTIFICATE_REVOKED_BUTTON",
}
